export const KEY_PROPERTY_CATEGORIES = "property-categories";
export const KEY_COMPANY_DETAILS = "company-details";